// The automatic first step: required launch inputs nobody supplied (a menu
// launch of a wizard that expects a pick list number). A target column with
// fixed values offers them; anything else is typed.

import { useState } from 'react'
import { columnOf, parseTarget } from '../model'
import { T, button, input as inputStyle } from '../styles'
import { tw } from '../../testHooks'
import type { StepProps } from './common'

export default function StartStep({ ctl, handheld }: StepProps) {
  const { startInputs, fi, busy } = ctl
  const [values, setValues] = useState<Record<string, unknown>>({})
  if (!fi) return null
  const ready = startInputs.every(i => String(values[i.name] ?? '').trim() !== '')
  return (
    <form onSubmit={e => { e.preventDefault(); if (ready) void ctl.submitStart(values) }}
      style={{ display: 'flex', flexDirection: 'column', gap: 12 }} {...tw('wizard-step', '__start')}>
      {startInputs.map((inp, idx) => {
        const t = inp.target ? parseTarget(inp.target, fi) : null
        const col = t && t.scope !== 'var' ? columnOf(fi, t.formNo, t.name) : null
        const opts = col?.edit_mask?.values || []
        const label = inp.label || String(col?.heading || inp.name)
        const id = `wz-in-${inp.name}`
        return (
          <div key={inp.name} style={{ display: 'flex', flexDirection: 'column', gap: 4 }} {...tw('field', `input.${inp.name}`)}>
            <label htmlFor={id} style={{ fontSize: 14, fontWeight: 600, color: T.text }}>{label}</label>
            {opts.length ? (
              <select id={id} style={inputStyle(handheld)} value={String(values[inp.name] ?? '')}
                onChange={e => setValues(v => ({ ...v, [inp.name]: e.target.value }))}>
                <option value="">— choose —</option>
                {opts.map(o => <option key={o.data} value={o.data}>{o.display || o.data}</option>)}
              </select>
            ) : (
              <input id={id} style={inputStyle(handheld)} autoFocus={idx === 0}
                type={inp.type === 'number' ? 'number' : inp.type === 'date' ? 'date' : 'text'}
                value={String(values[inp.name] ?? '')}
                onChange={e => setValues(v => ({ ...v, [inp.name]: e.target.value }))} />
            )}
          </div>
        )
      })}
      <div>
        <button type="submit" style={button(handheld, true, !ready || !!busy)} disabled={!ready || !!busy}
          {...tw('wizard-next', '1')}>Start</button>
      </div>
    </form>
  )
}
